import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { memo } from 'react';

export const Route = createFileRoute('/_unauthenticated')({
  component: memo(UnAuthenticationLayout),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/',
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
});

function UnAuthenticationLayout() {
  return <Outlet />;
}
